import logo from '@assets/logo.svg';
import { Box } from '@components/ui/atoms/Box';
import { Button } from '@components/ui/atoms/Button';
import { Container } from '@components/ui/atoms/Container';
import { Flex } from '@components/ui/atoms/Flex';
import { Image } from '@components/ui/atoms/Image';
import { Text } from '@components/ui/atoms/Text';
import { useAuthContext } from '@shared/auth/AuthProvider';
import { Add, ArrowRight, HamburgerMenu } from 'iconsax-reactjs';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { loginPath, signupPath } from '../auth/urls';
import { dashboardPath } from '../dashboard/urls';

export const LandingPageHeader: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { authenticated } = useAuthContext();

  const goToDashboard = () => {
    window.location.assign(dashboardPath);
  };

  return (
    <Box
      w="full"
      bg="white"
      px="2rem"
      py="1rem"
      position="relative"
      borderBottom="1px solid"
      borderColor="gray.200"
      zIndex={20}
    >
      <Container maxW="container.xl">
        <Flex align="center" justify="space-between">
          <RouterLink to="/">
            <Flex align="center" gap="0.5rem">
              <Image src={logo} w={{ base: 8, md: 10 }} h={{ base: 8, md: 10 }} alt="logo" />
              <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'lg' }} color="gray.800">
                Bhutan Payments
              </Text>
            </Flex>
          </RouterLink>

          <Flex align="center" gap="3rem" display={{ base: 'none', md: 'flex' }}>
            <RouterLink to="/">
              <Text fontWeight="500" color="gray.600" _hover={{ color: 'purple.600' }}>
                Home
              </Text>
            </RouterLink>
            <a href="/#services">
              <Text fontWeight="500" color="gray.600" _hover={{ color: 'purple.600' }}>
                Services
              </Text>
            </a>
            <a href="/#supported">
              <Text fontWeight="500" color="gray.600" _hover={{ color: 'purple.600' }}>
                Supported Users
              </Text>
            </a>
          </Flex>

          <Flex align="center" gap="1rem">
            <Box display={{ base: 'none', md: 'flex' }}>
              {authenticated ? (
                <Button visual="primary" px="1.5rem" borderRadius="md" onClick={goToDashboard}>
                  <Flex align="center" gap="0.5rem">
                    Dashboard <ArrowRight size="16" />
                  </Flex>
                </Button>
              ) : (
                <>
                  <RouterLink to={loginPath}>
                    <Button visual="secondary" px="1.5rem" borderRadius="md">
                      <Flex align="center" gap="0.5rem">
                        Sign in
                      </Flex>
                    </Button>
                  </RouterLink>
                  <RouterLink to={signupPath}>
                    <Button visual="primary" ml="1rem" px="1.5rem" borderRadius="md">
                      <Flex align="center" gap="0.5rem">
                        Sign Up
                      </Flex>
                    </Button>
                  </RouterLink>
                </>
              )}
            </Box>

            <Box
              display={{ base: 'block', md: 'none' }}
              cursor="pointer"
              onClick={() => {
                setIsMobileMenuOpen(!isMobileMenuOpen);
              }}
            >
              {isMobileMenuOpen ? (
                <Add size="28" color="#4A5568" style={{ transform: 'rotate(45deg)' }} />
              ) : (
                <HamburgerMenu size="28" color="#4A5568" />
              )}
            </Box>
          </Flex>
        </Flex>
      </Container>

      {isMobileMenuOpen && (
        <Box
          position="absolute"
          top="100%"
          left="0"
          right="0"
          bg="white"
          boxShadow="lg"
          zIndex={100}
          p="1.5rem"
          display={{ base: 'flex', md: 'none' }}
          flexDirection="column"
          gap="1.5rem"
          borderTop="1px solid"
          borderColor="#EDF2F7"
        >
          <RouterLink
            to="/"
            onClick={() => {
              setIsMobileMenuOpen(false);
            }}
          >
            <Text fontWeight="500" color="gray.700" fontSize="md">
              Home
            </Text>
          </RouterLink>
          <a
            href="/#services"
            onClick={() => {
              setIsMobileMenuOpen(false);
            }}
          >
            <Text fontWeight="500" color="gray.700" fontSize="md">
              Services
            </Text>
          </a>
          <a
            href="/#supported"
            onClick={() => {
              setIsMobileMenuOpen(false);
            }}
          >
            <Text fontWeight="500" color="gray.700" fontSize="md">
              Supported Users
            </Text>
          </a>

          {authenticated ? (
            <Button
              visual="primary"
              w="full"
              size="md"
              borderRadius="md"
              py="1.1rem"
              mt="0.5rem"
              onClick={() => {
                setIsMobileMenuOpen(false);
                goToDashboard();
              }}
            >
              <Flex align="center" justify="center" gap="0.5rem">
                Dashboard <ArrowRight size="16" />
              </Flex>
            </Button>
          ) : (
            <>
              <RouterLink
                to={loginPath}
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
              >
                <Button
                  visual="secondary"
                  w="full"
                  size="md"
                  borderRadius="md"
                  py="1.1rem"
                  mt="0.5rem"
                >
                  <Flex align="center" justify="center" gap="0.5rem">
                    Sign in
                  </Flex>
                </Button>
              </RouterLink>
              <RouterLink
                to={signupPath}
                onClick={() => {
                  setIsMobileMenuOpen(false);
                }}
              >
                <Button visual="primary" w="full" size="md" borderRadius="md" py="1.1rem">
                  <Flex align="center" gap="0.5rem">
                    Sign Up
                  </Flex>
                </Button>
              </RouterLink>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};

LandingPageHeader.displayName = 'LandingPageHeader';
